var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.id > 0 ? "stationBox" : "" },
    [
      _vm.id > 0
        ? _c("div", { staticClass: "title flex-between" }, [
            _c("div", { staticClass: "ml30" }, [_vm._v("基本信息")]),
            _vm._v(" "),
            _vm.drawerType !== "info"
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.drawerEdit("info")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("public.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleConfirm("ruleForm")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("public.ok")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.drawerType == "info" && _vm.formInfo.operate
              ? _c(
                  "div",
                  {
                    staticClass: "editText",
                    on: {
                      click: function ($event) {
                        return _vm.drawerEdit("edit")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-edit" }),
                    _vm._v("编辑\n    "),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mr14", class: _vm.id == 0 ? "mt20" : "" },
        [
          _vm.drawerType !== "info"
            ? _c(
                "el-form",
                {
                  ref: "formData",
                  attrs: {
                    model: _vm.formData,
                    "label-width": "110px",
                    rules: _vm.rule,
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "项目名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "input-item",
                        attrs: { size: "small", placeholder: "请输入项目名称" },
                        model: {
                          value: _vm.formData.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "select-bar",
                      attrs: { label: "负责人：", prop: "uid" },
                    },
                    [
                      _c("select-member", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "only-one": true,
                          value: _vm.principal || [],
                          placeholder: "请选择负责人",
                        },
                        on: {
                          getSelectList: function ($event) {
                            return _vm.getSelectList($event, 1)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "select-bar",
                      attrs: { label: "项目成员：" },
                    },
                    [
                      _c("select-member", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          value: _vm.userList || [],
                          placeholder: "请选择成员",
                        },
                        on: {
                          getSelectList: function ($event) {
                            return _vm.getSelectList($event, 2)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "select-bar",
                      attrs: { label: "计划开始：", prop: "start_date" },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          size: "small",
                          type: "date",
                          clearable: "",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "请选择项目计划开始日期",
                        },
                        model: {
                          value: _vm.formData.start_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "start_date", $$v)
                          },
                          expression: "formData.start_date",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "select-bar",
                      attrs: { label: "计划结束：", prop: "end_date" },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          size: "small",
                          type: "date",
                          clearable: "",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "请选择项目计划结束日期",
                        },
                        model: {
                          value: _vm.formData.end_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "end_date", $$v)
                          },
                          expression: "formData.end_date",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联客户：", prop: "eid" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "custom-select",
                          attrs: {
                            size: "small",
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择关联客户",
                          },
                          on: { change: _vm.handleContract },
                          model: {
                            value: _vm.formData.eid,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "eid", $$v)
                            },
                            expression: "formData.eid",
                          },
                        },
                        _vm._l(_vm.customerList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formData.eid
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "关联合同：", prop: "cid" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "custom-select",
                              attrs: {
                                size: "small",
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择关联合同",
                              },
                              model: {
                                value: _vm.formData.cid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "cid", $$v)
                                },
                                expression: "formData.cid",
                              },
                            },
                            _vm._l(_vm.contractList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "项目状态：", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "status", $$v)
                            },
                            expression: "formData.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("正常"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("暂停"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "项目描述：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "1000",
                          "show-word-limit": "",
                          rows: 3,
                          placeholder: "请输入项目描述，最多可输入1000字",
                        },
                        model: {
                          value: _vm.formData.describe,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "describe", $$v)
                          },
                          expression: "formData.describe",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.id == 0
        ? _c(
            "div",
            { staticClass: "button from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleConfirm("ruleForm")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.drawerType == "info"
        ? _c("details-program", {
            ref: "detailsProgram",
            attrs: { formData: _vm.formData },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.id > 0 && _vm.formInfo.operate
        ? _c(
            "div",
            { staticClass: "delText mb20" },
            [
              _c(
                "el-button",
                {
                  staticClass: "delBtn ml30",
                  attrs: { plain: "", size: "small" },
                  on: { click: _vm.handleDelete },
                },
                [_vm._v("删除项目")]
              ),
              _vm._v(
                "删除项目后将删除所有工作项，且数据无法找回，请谨慎操作\n  "
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }